import React, { useState, useEffect } from "react";
import useScrollFade from "../hooks/useScrollFade";

const ScrollToTop: React.FC = () => {
  const isVisible = useScrollFade(300);
  const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setIsCodeModalOpen(true);
    const onClose = () => setIsCodeModalOpen(false);
    window.addEventListener("codeModalOpen", onOpen);
    window.addEventListener("codeModalClose", onClose);
    return () => {
      window.removeEventListener("codeModalOpen", onOpen);
      window.removeEventListener("codeModalClose", onClose);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const animationClass = isCodeModalOpen
    ? "animate__fadeOutDown"
    : isVisible
      ? "animate__fadeInUp"
      : "animate__fadeOutDown";

  const classes = `scroll-to-top animate__animated animate__faster ${animationClass}`;

  return (
    <div
      onClick={isCodeModalOpen ? undefined : handleScrollToTop}
      className={classes}
      style={isCodeModalOpen ? { pointerEvents: "none" } : undefined}
    >
      <span className="material-symbols-outlined notranslate">vertical_align_top</span>
    </div>
  );
};

export default ScrollToTop;
